<template>
  <v-container>
    <v-layout
      align-center
      :style="{ backgroundImage: 'url(/images/sign-in-banner.png)' }"
      class="general-slide"
      row
      wrap
    >
      <v-container class="px-2">
        <v-row class="fill-height">
          <v-col
            cols="8"
            lg="6"
            md="5"
            class="right-fade-bg d-flex justify-center align-center"
          >
            <div>
              <h1 class="mb-2 text-h2">
                {{ t('sign_in.title') }}
              </h1>
              <p class="text-h4 my-6">
                {{ t('sign_in.line_1') }}
              </p>

              <v-btn
                v-if="signInUrls?.github"
                :href="signInUrls.github"
                class="mt-6"
                color="primary"
                elevation="2"
                size="x-large"
              >
                <v-icon
                  left
                  dark
                  class="mr-4"
                >
                  mdi-github
                </v-icon>
                {{ t('sign_in.github_btn') }}
              </v-btn>
              <br>
              <v-btn
                v-if="signInUrls?.openid"
                :href="signInUrls.openid"
                class="mt-6"
                color="primary"
                elevation="2"
                size="x-large"
              >
                <v-icon
                  left
                  dark
                  class="mr-4"
                >
                  mdi-openid
                </v-icon>
                {{ t('sign_in.openid_btn') }}
              </v-btn>
            </div>
          </v-col>
          <v-spacer />
        </v-row>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script setup lang="ts">
import {computed, onMounted} from 'vue';
import {useI18n} from 'vue-i18n';
import {useStore} from 'vuex';

import {getAccessToken} from '@/Foundation/helpers/storage';

const store = useStore();
const {t} = useI18n();

const signInUrls = computed(() => store.state.auth.signInUrls);

onMounted(() => {
  if (getAccessToken()) {
    window.location.href = '/cabinet/connections';
  } else {
    store.dispatch('auth/getSignInUrls');
  }
});
</script>

<script lang="ts">
export default {
  name: 'SignIn',
};
</script>